import React, { useEffect, useState } from 'react';
import './Hero.css';
import { Link } from 'react-router-dom';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const slides = [
  {
    image: '/images/slide1.jpg',
    heading: 'Innovating Healthcare',
    subheading: 'Quality pharma solutions for a better tomorrow.',
  },
  {
    image: '/images/slide2.jpg',
    heading: 'Trusted Formulations',
    subheading: 'Backed by research, driven by care.',
  },
  {
    image: '/images/slide3.jpg',
    heading: 'Your Health, Our Mission',
    subheading: 'Delivering excellence through every product.',
  },
];

const Hero = () => {
  const [current, setCurrent] = useState(0);

  // Auto Slide
  useEffect(() => {
    const timer = setInterval(() => {
      nextSlide();
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const { image, heading, subheading } = slides[current];

  return (
    <section className="hero" style={{ backgroundImage: `url(${image})` }}>
      <div className="hero-overlay">
        <h1>{heading}</h1>
        <p>{subheading}</p>
        <p className="hero-description">
  At Harrygen Labs, we combine innovation and care to deliver trusted pharmaceutical solutions across India.
</p>
<p className="scroll-down">Scroll down to explore ↓</p>

        <Link to="/products" className="hero-btn">Explore Products</Link>

        {/* Slide Navigation Buttons */}
        <div className="hero-nav">
          <button onClick={prevSlide} aria-label="Previous Slide"><FaChevronLeft /></button>
          <button onClick={nextSlide} aria-label="Next Slide"><FaChevronRight /></button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
